import { axiosPrivate } from "@app/dashboard/tools/axios/axiosInstance"
import type { AxiosRequestConfig } from "axios";

interface CustomAxiosRequestConfig extends AxiosRequestConfig {
    allow403?: boolean;
};

export const connectDisconnect = (payload: { action: string, account_id: string }) => {
    return axiosPrivate.post('/bills/api/v1/converted-pay/connect-disconnect/', payload, { allow403: true } as CustomAxiosRequestConfig);
}

